import { render } from "./MedalStar.vue?vue&type=template&id=b1f0476a"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/MedalStar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b1f0476a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b1f0476a', __exports__)) {
    api.reload('b1f0476a', __exports__)
  }
  
  module.hot.accept("./MedalStar.vue?vue&type=template&id=b1f0476a", () => {
    api.rerender('b1f0476a', render)
  })

}


export default __exports__